import React, { createContext, useContext } from 'react';
import { HelmetProvider } from 'react-helmet-async';

interface SEOContextProps {
  children: React.ReactNode;
}

const SEOContext = createContext<null>(null);

export const SEOProvider: React.FC<SEOContextProps> = ({ children }) => {
  return (
    <HelmetProvider>
      {children}
    </HelmetProvider>
  );
};

export const useSEO = () => {
  const context = useContext(SEOContext);
  return context;
};

export default SEOProvider;
